import React from 'react';
import './DurationSelector.scss';

interface DurationOption {
  hours: number;
  label: string;
  popular?: boolean;
}

interface DurationSelectorProps {
  selectedDuration: number;
  onSelect: (hours: number) => void;
  maxDuration?: number;
}

const DEFAULT_OPTIONS: DurationOption[] = [
  { hours: 1, label: '1 Hour' },
  { hours: 5, label: '5 Hours' },
  { hours: 12, label: '12 Hours' },
  { hours: 24, label: '24 Hours', popular: true },
  { hours: 72, label: '3 Days' },
];

export const DurationSelector: React.FC<DurationSelectorProps> = ({
  selectedDuration,
  onSelect,
  maxDuration = 72,
}) => {
  // Filter options based on max duration
  const availableOptions = DEFAULT_OPTIONS.filter(opt => opt.hours <= maxDuration);

  return (
    <div className="duration-selector">
      <div className="duration-label">Select Duration:</div>
      <div className="duration-options">
        {availableOptions.map((option) => (
          <button
            key={option.hours}
            className={`duration-option ${selectedDuration === option.hours ? 'selected' : ''} ${option.popular ? 'popular' : ''}`}
            onClick={() => onSelect(option.hours)}
          >
            {option.popular && <span className="popular-badge">Popular</span>}
            <span className="duration-text">{option.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DurationSelector;
